import permissions from './permission-list'

export default [
  {
    path: '/faq-categories',
    name: 'faq-categories',
    component: () => import('@/views/faq-categories/index.vue'),
    meta: {
      pageTitle: 'Kategori FAQ',
      resource: permissions.faqCategory,
      action: 'read',
      navActiveLink: 'faq-categories',
      breadcrumb: [
        {
          text: 'Daftar Kategori FAQ',
          active: true,
        },
      ],
    },
  },
  {
    path: '/faq-categories/create',
    name: 'faq-categories-create',
    component: () => import('@/views/faq-categories/create.vue'),
    meta: {
      pageTitle: 'Buat FAQ',
      resource: permissions.faqCategory,
      action: 'manage',
      navActiveLink: 'faq-categories',
      breadcrumb: [
        {
          text: 'FAQ',
          active: false,
          to: { path: '/faq' },
        },
        {
          text: 'Buat',
          active: true,
        },
      ],
    },
  },
  {
    path: '/faq-categories/:id/edit',
    name: 'faq-categories-edit',
    component: () => import('@/views/faq-categories/edit.vue'),
    meta: {
      pageTitle: 'Edit Kategori FAQ',
      resource: permissions.faqCategory,
      action: 'manage',
      navActiveLink: 'faq-categories',
      breadcrumb: [
        {
          text: 'Kategori FAQ',
          active: false,
          to: { path: '/faq-categories' },
        },
        {
          text: 'Edit',
        },
      ],
    },
  },
]
